import React from 'react';
import MessageBox, { Props as PropsMessageBox } from './MessageBox';

export interface Props extends PropsMessageBox {
  icon?: React.ReactNode;
  children?: React.ReactNode;
}

export default function WarnMessage(props: Props) {
  return <MessageBox background="orange" {...props} />;
}
